
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sponser",
      function () {
        return require("private-next-pages/sponser.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sponser"])
      });
    }
  